import PageHeader from '../components/PageHeader.jsx'
import { IconArrow } from '../components/icons.jsx'
import styles from './PricingEngine.module.css'

// The real, standalone SR Pricing Engine (its own cookie-session login, full
// depth + role gating). Pricing stays a SEPARATE app — the hub deep-links out.
const ENGINE_URL = 'https://pricing.srchamp.com'

export default function PricingEngine() {
  return (
    <div className="fade-up">
      <PageHeader
        eyebrow="Quoting"
        title="SR Pricing Engine"
        lead="Build and revise customer estimates across SR’s product lines. Save the exact configuration, review the selling price and request ownership review when needed."
      />

      <div className={styles.hero}>
        <div className={styles.heroMain}>
          <div className={styles.badge}>
            <span className={styles.badgeDot} />
            Live · standalone engine
          </div>
          <h2 className={styles.heroTitle}>Open the pricing engine to build a quote.</h2>
          <p className={styles.heroLead}>
            Sign in to the secure pricing application with your SR
            credentials. Reps see the customer-facing selling price and estimate;
            ownership sees the full margin, discretionary-bonus, and cost model. It
            opens in a new tab so you keep the hub open alongside it.
          </p>

          <div className={styles.actions}>
            <a
              className={`btn btn-primary ${styles.cta}`}
              href={ENGINE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open SR Pricing Engine
              <IconArrow width={17} height={17} />
            </a>
            <span className={styles.ctaNote}>Opens in a new tab · separate sign-in</span>
          </div>
        </div>

        <ul className={styles.points}>
          <li><strong>Championship rings, coins, pins, headwear, jackets and uniforms</strong>. Custom work follows ownership review.</li>
          <li><strong>Consistent estimates</strong> based on the current configuration and quantity.</li>
          <li><strong>Role-gated</strong> — cost, margin, and bonus math stay ownership-level.</li>
          <li><strong>Quotes & approvals</strong> — saved estimates, quote numbers, and the approval queue live in the engine.</li>
        </ul>
      </div>

      <p className={styles.legacy}>
        Pricing intentionally runs as its own application; the hub links to it rather than
        embedding it. If the button doesn’t open, go directly to{' '}
        <a className={styles.legacyLink} href={ENGINE_URL} target="_blank" rel="noopener noreferrer">
          the pricing engine
        </a>.
      </p>
    </div>
  )
}
